import { ReactNode } from "react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

interface LayoutProps {
  children: ReactNode;
}

/**
 * Struttura comune a tutte le pagine: navigazione fissa in alto, contenuto,
 * footer e pulsante WhatsApp flottante. Garantisce che il menu sia presente
 * ovunque, comprese le pagine dei singoli trattamenti.
 */
const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
